'use client';
import { ReactNode, useState } from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { useBrand } from './brand-context';

interface Props {
  // The app's own CoverRight logo (theme-specific)
  coverRightLogo: ReactNode;
  height?: number;
}

// "brand | CoverRight" header logo. The brand logo links back to the partner's b2b page;
// if it fails to load, only the CoverRight logo is shown.
export function BrandLogo({ coverRightLogo, height = 36 }: Props) {
  const brand = useBrand();
  const [failed, setFailed] = useState(false);

  if (!brand?.logo || failed) {
    return <>{coverRightLogo}</>;
  }

  return (
    <Stack gap={2} direction={'row'} alignItems={'center'}>
      <Box component={brand.url ? 'a' : 'span'} href={brand.url} sx={{ display: 'flex' }}>
        <Box
          component={'img'}
          src={brand.logo}
          alt={''}
          onError={() => setFailed(true)}
          sx={{ height, maxWidth: 180, objectFit: 'contain' }}
        />
      </Box>
      <Divider orientation={'vertical'} sx={{ alignSelf: 'stretch', height: 'auto', borderColor: '#a4b4b9' }} />
      {coverRightLogo}
    </Stack>
  );
}
